var capitalize = function capitalize(s) {
  if (typeof s !== 'string') return '';
  return s.toLowerCase().charAt(0).toUpperCase() + s.slice(1);
};
export default capitalize;